import { ScoopCenter, ScoopColumn } from '../../ui'
import { ScoopButton, ScoopScreenLayout } from '../../ui'
import { ScoopSpinner } from '../../ui'
import { BrowsersIcon, PlusIcon } from '@phosphor-icons/react'
import { EmptyLiveQuery } from './EmptyLiveQuery/EmptyLiveQuery'
import { LiveQueryRow } from './LiveQueryRow/LiveQueryRow'
import { useToast } from '../../ui'
import { useExternalTables } from '../../../api/hooks/externalTables/useExternalTables'
import { HelpBotPromptButton } from '../../HelpBot/components/HelpBotPromptButton/HelpBotPromptButton'
import { HELP_BOT_PROMPTS } from '../../HelpBot/helpBotPrompts'
import { useModal, MODALS } from '../../modals'
import styles from './LiveQuery.module.scss'

export const LiveQuery = () => {
    const toast = useToast()
    const createWizardModal = useModal(MODALS.LIVE_QUERY.CREATE_WIZARD)

    const { externalTables, loadingExternalTables, deleteTable, isDeletingTable } =
        useExternalTables()

    const handleOpenWizard = async () => {
        const result = await createWizardModal.show({
            onCreate: (tableData) => {
                toast.success(`Live Query "${tableData.metadata.name}" created successfully!`)
            },
        })
        return result
    }

    const handleDeleteTable = (inboxID) => {
        deleteTable(inboxID, {
            onSuccess: () => {
                toast.success('Live Query connection deleted successfully')
            },
            onError: (error) => {
                toast.error(error.message || 'Failed to delete Live Query connection')
            },
        })
    }

    return (
        <>
            <ScoopScreenLayout
                title={
                    <>
                        Live Query
                        <HelpBotPromptButton
                            prompt={HELP_BOT_PROMPTS.LIVE_QUERY_SCREEN}
                            variant="icon"
                            iconMinimal
                            tooltip="Query data directly from your databases without importing. Click to learn more."
                            tooltipPlacement="right"
                        />
                    </>
                }
                icon={<BrowsersIcon size={32} className={styles.headerIcon} />}
                headerActions={
                    externalTables.length > 0 && (
                        <ScoopButton
                            onClick={handleOpenWizard}
                            variant="default"
                            leftSection={<PlusIcon size={18} weight="bold" />}
                        >
                            New Live Query
                        </ScoopButton>
                    )
                }
            >
                {loadingExternalTables ? (
                    <ScoopCenter style={{ padding: '80px 0' }}>
                        <ScoopSpinner size={32} />
                    </ScoopCenter>
                ) : externalTables.length === 0 ? (
                    <ScoopCenter className={styles.emptyState}>
                        <EmptyLiveQuery onCreateClick={handleOpenWizard} />
                    </ScoopCenter>
                ) : (
                    <ScoopColumn className={styles.tableList}>
                        {externalTables.map((table) => (
                            <LiveQueryRow
                                key={table.inboxID}
                                table={table}
                                onDelete={handleDeleteTable}
                                isDeleting={isDeletingTable}
                            />
                        ))}
                    </ScoopColumn>
                )}
            </ScoopScreenLayout>
        </>
    )
}
